/**
 * Shared brand design tokens for admin pages (single source of truth).
 */
export const PRIMARY = '#6C98AD';
export const PRIMARY_HOVER = '#5a8499';
export const SECONDARY = '#24272a';
export const CARD_SHADOW = '0 4px 20px rgba(108, 152, 173, 0.15)';
export const CARD_SHADOW_HOVER = '0 8px 30px rgba(108, 152, 173, 0.25)';
export const FONT_HEADING = "'Avenir Next LT Pro', sans-serif";
export const FONT_BODY = "'Avenir Next LT Pro', sans-serif";
export const RADIUS = '1rem';
export const TRANSITION = 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
